import { FormGroup, Grid } from '@mui/material'
import { CatalogProductType } from '../enums'
import { CatalogProduct } from '../types'
import { GeneratorCatalogProduct } from '../types/CatalogProduct'
import { GeneratorCatalogProductCustomDataInput } from '../types/CatalogProductInput'
import { useTranslation } from 'react-i18next'
import CatalogProductForm from './CatalogProductForm'
import GeneratorPowerSourceSelect from './GeneratorPowerSourceSelect'
import PhaseToggleButtonGroup from './PhaseToggleButtonGroup'
import GeneratorApparentPowerField from './GeneratorApparentPowerField'

export interface GeneratorCatalogProductFormProps {
  catalogProduct?: GeneratorCatalogProduct
  onCancel?: () => void
  onError?: (error: unknown) => void
  afterSubmit?: (catalogProduct: CatalogProduct) => void
}

export default function GeneratorCatalogProductForm({
  catalogProduct,
  ...props
}: GeneratorCatalogProductFormProps) {
  return (
    <CatalogProductForm
      {...props}
      type={CatalogProductType.GENERATOR}
      catalogProduct={catalogProduct}
    />
  )
}

/**
 * The custom data fields of a generator catalog product.
 */
export function GeneratorCatalogProductCustomDataFields({
  value,
  disabled = false,
  isError,
  getHelperText,
  onChange
}: {
  value: GeneratorCatalogProductCustomDataInput
  catalogProduct?: CatalogProduct
  disabled?: boolean
  isError?: (field: string) => boolean
  getHelperText?: (field: string) => string | undefined
  onChange: (value: GeneratorCatalogProductCustomDataInput) => void
}) {
  const { t } = useTranslation('catalogProduct')

  return (
    <FormGroup>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <GeneratorPowerSourceSelect
            label={t('powerSource')}
            value={value.powerSource}
            error={isError?.('customData.powerSource')}
            helperText={getHelperText?.('customData.powerSource')}
            disabled={disabled}
            variant="outlined"
            fullWidth
            onSelect={(powerSource) => onChange({ ...value, powerSource })}
          />
        </Grid>

        <Grid item xs={12}>
          <PhaseToggleButtonGroup
            fullWidth
            size="small"
            value={value.nominalVoltage === undefined || value.nominalVoltage <= 230 ? 1 : 3}
            disabled={disabled}
            onChange={(_event, phase) =>
              onChange({ ...value, nominalVoltage: phase === 1 ? 230 : 400 })
            }
          />
        </Grid>

        <Grid item xs={12}>
          <GeneratorApparentPowerField
            value={value.apparentPower}
            error={isError?.('customData.apparentPower')}
            helperText={getHelperText?.('customData.apparentPower')}
            disabled={disabled}
            onChange={(event) =>
              onChange({
                ...value,
                apparentPower: event.target.value === '' ? undefined : Number(event.target.value)
              })
            }
          />
        </Grid>
      </Grid>
    </FormGroup>
  )
}
